export default __webpack_public_path__ + "static/Dan_Rather_Homepage_Poster-781ff9671891efbacd2f65d6f6738343.jpg";